
export function $(x) {
    const z = document.querySelector(x);
    if(!z) {
        return null;
    }
    return $fun(z);
}

function is_node(ele) {
    return (ele && ele.nodeName && ele.nodeType);
}

export function $txt(t) {
    return document.createTextNode(t);
}

function add_children(ele, ...args) {
    let kids = args.flat();
    for(let kid of kids) {
        if(kid === undefined) {
            continue;
        }
        if(Array.isArray(kid)) {
            add_children(ele, ele.as_array(...kid));
        } else if(!is_node(kid)) {
            ele.appendChild( ele.as_item($txt(kid)));
        } else {
            ele.appendChild( ele.as_item(kid));
        }
    }
    return ele;
}
function add_attributes(ele, attr) {
    if(!attr) {
        return;
    }
    if(attr.class) {
        if(!Array.isArray(attr.class)) {
            attr.class = attr.class.split(" ").filter(v => v.length);
        }
        attr.class.forEach(att => ele.classList.add(att));
    }
    if(attr.style) {
        if(typeof attr.style === "string") {
            ele.style.cssText = attr.style;
        } else if(typeof attr.style === "object") {
            for (let [key, value] of Object.entries(attr.style)) {
                ele.style.setProperty(key, value);
            }
        }
    }
    for(let [key, value] of Object.entries(attr)) {
        if(key == 'class' || key == 'style') {
            continue;
        }
        if(key == 'display') {
            ele.style.display = value;
            continue;
        }
        if(typeof value === 'function') {
            ele.addEventListener(key, value);
        } else if(value === false) {
            ele.removeAttribute(key);
        } else if(key == "value") { // setAttribute does not work for color
            ele.value = value;
        } else {
            ele.setAttribute(key, value);
        }
    }
}

function show_hide(ele, show) {
    const display = ele.style.display;
    if(show === undefined) {
        show = display === "none";
    }
    if(show && display === "none") {
        if(ele._display === "none") {
            ele.style.display = 'block';
        } else {
            ele.style.display = ele._display;
        }
    } else if(!show && display !== "none") {
        ele.style.display = "none";
    }
}
function def_display(ele) {
    //if(ele.style.display === "none") {
    //    return "";
    //}
    return ele.style.display;
}

export function $fun(ele) {
    ele.add = (...kids) => add_children(ele, kids);
    ele.attr = (attr) => add_attributes(ele, attr);
    ele.as_item = (item) => item;
    ele.as_array = (...items) => items;
    ele.show = () => show_hide(ele, true);
    ele.hide = () => show_hide(ele, false);
    ele.toggle = () => show_hide(ele, undefined);
    ele._display = def_display(ele);
    ele.clear = () => ele.replaceChildren();
    ele.set = (...kids) => { ele.clear(); ele.add(kids); };
    return ele;
}

export function $ele(tag, funcs = undefined) {
    const types = ["string", "number", "boolean", "bigint"];
    return (...argv) => {
        let kids = [];
        let attr = {};
        const args = argv;
        for(const arg of args) {
            if(Array.isArray(arg) || is_node(arg) || types.includes(typeof arg)) {
                kids.push(arg);
            } else if (typeof arg === "undefined") {
            } else if (arg === null) {
            } else {
                attr = Object.assign(attr, arg)
            }
        }
        let ele = $fun(document.createElement(tag));
        if(funcs) {
            if(funcs.as_item) {
                ele.as_item = funcs.as_item;
            }
            if(funcs.as_array) {
                ele.as_array = funcs.as_array;
            }
        }
        ele.add(...kids);
        ele.attr(attr);
        ele._display = def_display(ele);
        return ele;
    }
}
export const $div = $ele('div');
export const $li = $ele('li');
//export const $a = $ele('a');
export const $input = $ele('input');
export const $tarea = $ele('textarea');
export const $button = $ele('button');
export const $row = function (...argv) { return $div(...argv, {class: "row"}); };
export const $col = function (...argv) { return $div(...argv, {class: "col"}); };
export const $img = $ele('img');
export const $hr = $ele('hr');
export const $br = $ele('br');
export const $select = $ele('select');
export const $option = $ele('option');
export const $label = $ele('label');

const $i = $ele('i');
export function $icon(name, arg) {
    let attr = { class: `fa fa-${name}`, "aria-hidden": "true" };
    attr = Object.assign(attr, arg)
    return $i('', attr );
}

function ul_as_item (item) {
    if(item.nodeName.toLowerCase() == "ul") {
        return item;
    }
    return $li(item);
};

function ul_as_array (...items) {
    return $ul(...items);
};
export let $ul = $ele('ul', {as_item: ul_as_item, as_array: ul_as_array});


export async function $json(filename) {
    const res = await fetch(filename);
    if(!res.ok) {
        return []
    }
    return res.json();
}
export function $a(txt, url, onclick=undefined) {
    let a = document.createElement('a');
    a.appendChild($txt(txt));
    a.title = "txt";
    if(url == "#") {
        a.href = "javascript:void(0)";
    } else {
        a.href = url;
    }
    if(onclick) {
        a.addEventListener('click', onclick);
    }
    return a;
}
